export const TABLE_BODY_CELL_HEIGHT = 60;
export const TABLE_BODY_CELL_PADDING = '8px 16px';
